import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  listsRequest: ['sort_field', 'sort_order'],
  listsSuccess: ['list'],

  listRequest: ['id'],
  listSuccess: ['focusRow'],
  listReset: null,

  listSaveRequest: ['data'],
  listSaveSuccess: ['saveResult'],
  listSaveReset: null,

  listDeleteRequest: ['id'],
  listDeleteSuccess: ['deleteResult'],
  listDeleteReset: null,

  listRestoreRequest: ['id'],
  listRestoreSuccess: ['restoreResult'],
  listRestoreReset: null,

  listMakeDefaultRequest: ['id'],
  listMakeDefaultSuccess: ['folderId', 'makeDefaultResult'],
  listMakeDefaultReset: null,

  listsReset: null,

  listsFetchingReset: null,
})

export const ListsTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  saveResult: null,
  saveFetching: false,

  deleteResult: null,
  deleteFetching: false,

  restoreResult: null,
  restoreFetching: false,

  makeDefaultResult: null,
  makeDefaultFetching: false,

  page: 1,
  page_size: 12,

  focusRow: null,
})

/* ------------- Selectors ------------- */
export const ListsSelectors = {
  getState: state => state.lists,
}

/* ------------- Reducers ------------- */

export const listsRequest = (state, {sort_field, sort_order}) => {
  return state.merge({fetching: true})
}

export const listsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const listRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const listSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}

export const listsReset = state => {
  return INITIAL_STATE
}

export const listReset = state => {
  return state.merge({focusRow: null})
}

export const listSaveRequest = (state, {data}) => {
  return state.merge({saveFetching: true})
}

export const listSaveSuccess = (state, {saveResult}) => {
  const arrFoldersId = []
  let newResults = state.list?.results.map(folder => {
    arrFoldersId.push(folder.id)
    if (folder.id === saveResult.id) {
      return {...saveResult}
    } else {
      return {...folder}
    }
  })

  if (!arrFoldersId.includes(saveResult.id)) newResults = [saveResult, ...newResults]

  const newList = {...state.list, results: [...newResults]}

  return state.merge({saveFetching: false, saveResult, list: newList})
}

export const listSaveReset = state => {
  return state.merge({saveFetching: false, saveResult: null})
}

export const listDeleteRequest = (state, {id}) => {
  return state.merge({deleteFetching: true})
}

export const listDeleteSuccess = (state, {deleteResult}) => {
  return state.merge({deleteFetching: false, deleteResult})
}

export const listDeleteReset = state => {
  return state.merge({deleteFetching: false, deleteResult: null})
}

export const listRestoreRequest = (state, {id}) => {
  return state.merge({restoreFetching: true})
}

export const listRestoreSuccess = (state, {restoreResult}) => {
  return state.merge({restoreFetching: false, restoreResult})
}

export const listRestoreReset = state => {
  return state.merge({restoreFetching: false, restoreResult: null})
}

export const listMakeDefaultRequest = (state, {id}) => {
  return state.merge({makeDefaultFetching: true})
}

export const listMakeDefaultSuccess = (state, {folderId, makeDefaultResult}) => {
  const newResults = state.list?.results.map(folder => {
    if (folder.id === folderId) {
      return {...folder, is_default: true}
    } else {
      return {...folder, is_default: false}
    }
  })
  const newList = {...state.list, results: [...newResults]}

  return state.merge({makeDefaultFetching: false, makeDefaultResult, list: newList})
}

export const listMakeDefaultReset = state => {
  return state.merge({makeDefaultFetching: false, makeDefaultResult: null})
}

export const listsFetchingReset = state => {
  return state.merge({fetching: false, saveFetching: false, deleteFetching: false, makeDefaultFetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.LISTS_REQUEST]: listsRequest,
  [Types.LISTS_SUCCESS]: listsSuccess,

  [Types.LIST_REQUEST]: listRequest,
  [Types.LIST_SUCCESS]: listSuccess,

  [Types.LIST_SAVE_REQUEST]: listSaveRequest,
  [Types.LIST_SAVE_SUCCESS]: listSaveSuccess,
  [Types.LIST_SAVE_RESET]: listSaveReset,

  [Types.LIST_DELETE_REQUEST]: listDeleteRequest,
  [Types.LIST_DELETE_SUCCESS]: listDeleteSuccess,
  [Types.LIST_DELETE_RESET]: listDeleteReset,

  [Types.LIST_RESTORE_REQUEST]: listRestoreRequest,
  [Types.LIST_RESTORE_SUCCESS]: listRestoreSuccess,
  [Types.LIST_RESTORE_RESET]: listRestoreReset,

  [Types.LIST_MAKE_DEFAULT_REQUEST]: listMakeDefaultRequest,
  [Types.LIST_MAKE_DEFAULT_SUCCESS]: listMakeDefaultSuccess,
  [Types.LIST_MAKE_DEFAULT_RESET]: listMakeDefaultReset,

  [Types.LISTS_RESET]: listsReset,
  [Types.LIST_RESET]: listReset,

  [Types.LISTS_FETCHING_RESET]: listsFetchingReset,
})
